import { Component } from 'react';
import Icon from "@mui/material/Icon/Icon";
import Tooltip from '@mui/material/Tooltip';
import {getColorFromStatusLabel, getIconNameFromStatusLabel, getStatusLabel, isEditIcon} from '../../redux/absences/absencesActions'
import './AbsenceStatusIcon.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import '../../statusIcon.css'

class AbsenceStatusIcon extends Component {
    render() {
        let iconElement;

        if(isEditIcon(this.props.status)){
            iconElement = (
                <div className={this.props.className + " center font-awesome-align-center"}>
                    <FontAwesomeIcon className={"fa-lg status-icon-color-" + getColorFromStatusLabel(this.props.status, this.props.lowlight)} icon={faEdit} />
                </div>
            );
        }else{
            iconElement = (
                <Icon className={this.props.className + " center status-icon-color-" + getColorFromStatusLabel(this.props.status, this.props.lowlight)}>
                    {getIconNameFromStatusLabel(this.props.status)}
                </Icon>
            );
        }

        return (
            <Tooltip title={getStatusLabel(this.props.status)}>
                {iconElement}
            </Tooltip>
        );
    }
}

export default AbsenceStatusIcon;
